export default "__VITE_ASSET__7cf13a0f__"